// src/dialogs/PurchasesDialog.jsx
import React, { useMemo } from "react";
import {
  Dialog,
  Box,
  Typography,
  Stack,
  Button,
  Divider,
  Card,
  CardContent,
  Avatar,
} from "@mui/material";

import StoreIcon from "@mui/icons-material/Store";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { formatDate } from "../../../utils/helpers";

/**
 * PurchasesDialog
 *
 * NOW WORKS WITH:
 * - purchases[] OR devices[]
 */
export default function PurchasesDialog({
  open,
  onClose,
  purchases = [], // <-- devices passed here
  retailerInfo,
  activePurchaseId = null,
}) {
  
  console.log("retailer info: ", retailerInfo)
  /* ---------------- ADAPT DEVICES → PURCHASE SHAPE ---------------- */
  const adaptedPurchases = useMemo(() => {
    return purchases.map((d) => ({
      id: d.id,

      // UI expects these
      model_name: d.product_name || "Device",
      purchase_date: d.created_at || null,
      order_no: d.w_code || "—",
      serial_no: d.serial || "—",
      imei: d.imei1 || d.imei2 || "",
      warranty_expiry: d.expiry_date || null,

    }));
  }, [purchases]);

  /* ---------------- SORT ---------------- */
  const sortedPurchases = [...adaptedPurchases].sort((a, b) => {
    const da = new Date(a.purchase_date || 0).getTime();
    const db = new Date(b.purchase_date || 0).getTime();
    return db - da;
  });

  const uniqueShopCount = new Set(
    adaptedPurchases.map((p) => p?.purchased_from?.name?.toLowerCase())
  ).size;

  const retailerName = useMemo(() => {
  if (!retailerInfo) return "";
  return retailerInfo.business_name || "";
}, [retailerInfo]);


  const retailerAddress = useMemo(() => {
  if (!retailerInfo) return "";

  return [
    retailerInfo.address_line1,
    retailerInfo.address_line2,
    retailerInfo.city || retailerInfo.district,
    retailerInfo.state,
    retailerInfo.pincode,
  ]
    .filter(Boolean)
    .join(", ");
}, [retailerInfo]);

  console.log(" address: ", retailerAddress)

  return (
    <Dialog
  open={open}
  onClose={onClose}
  fullWidth
  sx={{
    "& .MuiDialog-paper": {
      margin: 0,
      width: "100%",
      borderRadius: "16px 16px 0 0",
      position: "fixed",
      bottom: 0,
    },
  }}
>
  <Box px={2} pt={2} pb={1}>
    {/* HEADER */}
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      mb={1}
    >
      <Box>
        <Typography fontSize={16} fontWeight={800}>
          Purchases
        </Typography>
        <Typography fontSize={12} color="text.secondary">
          {adaptedPurchases.length} items
        </Typography>
      </Box>

      <Button size="small" onClick={onClose}>
        Close
      </Button>
    </Stack>

    <Divider />

    {/* LIST */}
    <Box mt={1} sx={{ maxHeight: "65vh", overflowY: "auto" }}>
      {sortedPurchases.length === 0 ? (
        <Typography fontSize={13} color="text.secondary" mt={2}>
          No purchases found
        </Typography>
      ) : (
        <Stack spacing={1.2}>
          {sortedPurchases.map((p) => {
            const isActive = p.id === activePurchaseId;

            return (
              <Card
                key={p.id}
                elevation={0}
                sx={{
                  borderRadius: 2,
                  border: "1px solid",
                  borderColor: isActive ? "#2563eb" : "divider",
                  bgcolor: isActive ? "#eff6ff" : "#fff",
                }}
              >
                <CardContent sx={{ p: 1.5 }}>
                  <Stack direction="row" spacing={1.5}>
                    {/* ICON */}
                    <Avatar
                      sx={{
                        width: 40,
                        height: 40,
                        bgcolor: "#eff6ff",
                      }}
                    >
                      <StoreIcon color="primary" fontSize="small" />
                    </Avatar>

                    {/* CONTENT */}
                    <Box flex={1}>
                      <Typography fontSize={14} fontWeight={700}>
                        {p.model_name}
                      </Typography>

                      <Typography fontSize={12} color="text.secondary">
                        {retailerName}
                      </Typography>

                      <Typography fontSize={12} color="text.secondary">
                        Purchased on {formatDate(p.purchase_date)}
                      </Typography>

                      <Typography
                        fontSize={11}
                        color="text.secondary"
                        mt={0.5}
                      >
                        Order: {p.order_no}
                      </Typography>

                      {p.imei && (
                        <Typography fontSize={11} color="text.secondary">
                          IMEI: {p.imei}
                        </Typography>
                      )}

                      {p.warranty_expiry && (
                        <Typography fontSize={11} color="text.secondary">
                          Warranty till {formatDate(p.warranty_expiry)}
                        </Typography>
                      )}

                      {retailerAddress && (
                        <Stack
                          direction="row"
                          spacing={0.5}
                          alignItems="center"
                          mt={0.5}
                        >
                          <LocationOnIcon fontSize="inherit" />
                          <Typography fontSize={11} color="text.secondary">
                            {retailerAddress}
                          </Typography>
                        </Stack>
                      )}
                    </Box>
                  </Stack>
                </CardContent>
              </Card>
            );
          })}
        </Stack>
      )}
    </Box>
  </Box>
</Dialog>

  );
}




// // src/dialogs/PurchasesDialog.jsx
// import React from "react";
// import {
//   Dialog,
//   Box,
//   Typography,
//   Stack,
//   Button,
//   Divider,
//   Card,
//   CardContent,
//   Avatar,
// } from "@mui/material";

// import StoreIcon from "@mui/icons-material/Store";
// import LocationOnIcon from "@mui/icons-material/LocationOn";
// import { formatDate } from "../../../utils/helpers";

// /**
//  * PurchasesDialog
//  *
//  * Props:
//  * - open
//  * - onClose
//  * - purchases (array)
//  * - activePurchaseId (optional – highlight one)
//  */
// export default function PurchasesDialog({
//   open,
//   onClose,
//   purchases = [],
//   activePurchaseId = null,
// }) {
//   const sortedPurchases = [...purchases].sort((a, b) => {
//     const da = new Date(a.purchase_date || 0).getTime();
//     const db = new Date(b.purchase_date || 0).getTime();
//     return db - da;
//   });

//   const uniqueShopCount = new Set(
//     purchases.map((p) => p?.purchased_from?.name?.toLowerCase())
//   ).size;

//   return (
//     <Dialog open={open} onClose={onClose} fullWidth>
//       <Box p={3}>
//         {/* HEADER */}
//         <Stack direction="row" justifyContent="space-between" alignItems="center">
//           <Box>
//             <Typography variant="h6" fontWeight={900}>
//               Purchases
//             </Typography>
//             <Typography variant="body2" color="text.secondary">
//               {purchases.length} purchase
//               {purchases.length !== 1 ? "s" : ""} • {uniqueShopCount} shop
//               {uniqueShopCount !== 1 ? "s" : ""}
//             </Typography>
//           </Box>

//           <Button onClick={onClose}>Close</Button>
//         </Stack>

//         <Divider sx={{ my: 2 }} />

//         {/* LIST */}
//         {sortedPurchases.length === 0 ? (
//           <Typography variant="body2" color="text.secondary">
//             No purchases found.
//           </Typography>
//         ) : (
//           <Stack spacing={1.2}>
//             {sortedPurchases.map((p) => {
//               const isActive = p.id === activePurchaseId;

//               return (
//                 <Card
//                   key={p.id}
//                   variant="outlined"
//                   sx={{
//                     borderRadius: 2,
//                     cursor: "pointer",
//                     borderColor: isActive ? "#4f46e5" : undefined,
//                     bgcolor: isActive ? "rgba(79,70,229,0.04)" : undefined,
//                   }}
//                 >
//                   <CardContent sx={{ py: 1.5 }}>
//                     <Stack direction="row" spacing={1.5} alignItems="center">
//                       <Avatar sx={{ bgcolor: "#eef2ff" }}>
//                         <StoreIcon color="primary" />
//                       </Avatar>

//                       <Box flex={1}>
//                         <Typography fontWeight={900}>
//                           {p.model_name || "—"}
//                         </Typography>

//                         <Typography variant="body2" color="text.secondary">
//                           {p.purchased_from?.name || "—"} •{" "}
//                           {formatDate(p.purchase_date)}
//                         </Typography>

//                         <Typography
//                           variant="caption"
//                           color="text.secondary"
//                           display="block"
//                         >
//                           Order No: {p.order_no || "—"} • S/N:{" "}
//                           {p.serial_no || "—"}
//                           {p.imei ? ` • IMEI: ${p.imei}` : ""}
//                           {p.warranty_expiry
//                             ? ` • Expiry: ${formatDate(
//                                 p.warranty_expiry
//                               )}`
//                             : ""}
//                         </Typography>

//                         {p.purchased_from?.address && (
//                           <Stack
//                             direction="row"
//                             spacing={0.5}
//                             alignItems="center"
//                             mt={0.5}
//                           >
//                             <LocationOnIcon fontSize="small" />
//                             <Typography
//                               variant="caption"
//                               color="text.secondary"
//                             >
//                               {p.purchased_from.address}
//                             </Typography>
//                           </Stack>
//                         )}
//                       </Box>
//                     </Stack>
//                   </CardContent>
//                 </Card>
//               );
//             })}
//           </Stack>
//         )}
//       </Box>
//     </Dialog>
//   );
// }
